function Bokningsvillkor () {

return (
<section className="flex flex-col items-center py-14 px-6 bg-beige-light">
    <div className="space-y-4">
        <h2 className="text-3xl md:text-3xl font-serif mb-8">Bokningsvillkor</h2>
        <p className="leading-relaxed md:leading-normal ">
           
Vänligen läs igenom våra bokningsvillkor innan du bokar:<br/>
<br/>
– Avbokning ska ske senast 48h innan din bokade tid.<br/>
För att avboka din tid så kan du använda inloggningen på onlinebokningen, ringa till salongen eller maila oss på avbokning@studioclaire.se <b>Observera</b> att avbokning ej är giltig förrän du mottagit bekräftelse på avbokning via mail. <br/><br/>
– Vid avbokning senare än 48h innan din bokade tid debiterar vi  50% av behandlingspriset.<br/><br/>
– Vid avbokning senare än 24h innan din bokade tid debiterar vi 100% av behandlingspriset.<br/><br/>


Ingen ångerrätt:<br/>
Behandlingar som bokas för en bestämd dag omfattas inte av ångerrätten enligt distansavtalslagen (2 kap. 11 § p. 11).<br/>
Genom att boka godkänner du att ångerrätten upphör när behandlingen utförts.<br/>
<br/>
-Vid avbokning av extensions/löshår där hår specialbeställts till dig debiteras du 300:- för frakt/porto för att skicka tillbaka håret till vår leverantör.<br/>
<br/>

-När du kommer till din bokade tid har du som kund ansvar över att håret är rent och fritt från torrschampo, utväxtsprayer etc då detta kan påverka håret vid färgbehandlingar och ge ett oönskat resultat. Om din frisör behöver tvätta igenom håret innan behandlingen kostar detta 400:- utöver din bokade behandling  för extra åtgång av tid.<br/><br/>

-Du som kund har ansvar att informera din frisör om eventuella allergier, överkänslighet, användande av sprayblonde, egen brunn osv, detta för att vi ska kunna göra en sådan rättvis bedömning som möjligt om hårets kvalité och undvika eventuella kemiska reaktioner som kan skada ditt hår och hårbotten.<br/><br/>

-Alla kemiska behandlingar sker på kundens ansvar och vi frisörer ser till att alltid använda så skonsamma preparat och produkter för att nå önskat resultat utan att tumma på hårets kvalité.<br/>

-Du som kund ansvarar över att boka rätt behandling för dina önskemål, du kan läsa om alla våra behandlingar i vår behandlingsmeny , har du som kund bokat "fel" behandling så blir du informerad på plats av frisören och ni tillsammans konsulterar fram vad ni hinner göra på den tiden som är bokad.  Har du frågor som rör just ditt hår och är osäker på vilken behandling du ska välja, ring oss 076-0268462 eller maila på info@studioclaire.se <br/>
<br/>
- Olika priser efter vilken tid. <br/>
Kvällar/Helger tidiga morgnar kommer priserna att vara högre. Du hittar alla priser på onlinebokningen. <br/>
<br/>
-Efter din behandling<br/>
För att vi ska kunna ge garanti på din behandling så ansvarar du som kund att använda rekommenderade frisörprodukter och den eftervård som krävs för att hålla önskat resultat. <br/>
Reklamation på tjänst ska göras inom två veckor efter ditt besök. <br/>
Vi strävar efter att alla kunder ska vara 100% nöjd och därav lägger vi extra tid på konsultation och vikten av att du som kund är öppen med din hårhistoria. <br/>
Du som blekt/ljusat upp håret var extra noga med att inte smink/Brun utan sol etc färgar av sig på ditt hår. <br/>

        </p>
    </div>
</section>
);

}

export default Bokningsvillkor;